<div class="details-wrapper">
  <div class="list-wrapper">
    <div class="list-headers">
      <div class="image-spacer"></div>
      <div class="project-name">PROJECT NAME</div>
      <div class="spacer"></div>
      <div class="due-date">PUBLISH DATE</div>
      <div class="contributors">CONTRIBUTORS</div>
      <div class="status">STATUS</div>
    </div>
  </div>
  <a *ngFor="let project of projects?.items" routerLink="{{project | projectRoute }}">
    <styles-list-row
      class="list-item"
      imageUrl="{{ $any(pullDefaultAssetFile(project)) | AssetUrl : 'thumbnail' : undefined : 'current' : 'smartcrop' : 200 : 80 }}"
      [accentColour]="project | projectAccentColourPipe"
    >
      <div class="project-name-item">{{project | projectNamePipe}}</div>
      <div class="spacer"></div>
      <div class="date">
        <div class="due-date">{{( project | projectDueDatePipe | date:'d MMM, y') || '—' }}</div>
        <div class="last-active">Last Active {{(getLastActiveDate(project) | stylesDateHumanize) || '—'}}</div>
      </div>
      <div class="contributors">
        <framework-clusted-profile-images [userList]="[$any(project)?.owner]"></framework-clusted-profile-images>
      </div>
      <div class="status">
        <framework-work-status-chip [workStatus]="$any(project)?.status"></framework-work-status-chip>
      </div>
    </styles-list-row>
  </a>
</div>
